import styled, { css } from 'styled-components';
const ErrorMessageStyled = styled.div`
  ${() => {
    return css`
      color: #ca2121;
      font-size: 0.875em;
      line-height: 1.5em;
      display: flex;
      align-items: center;
      margin: 0.5em auto;
      width: 100%;
      max-width: 20.5em;
      span {
        width: 100%;
        display: block;
        margin: 0 0 0 0.5em;
      }
    `;
  }};
`;

export default ErrorMessageStyled;
